<template>
  <div :class="['container', (isPC && !showPC) ? 'pc_main' : '']">
    <!-- 切用户 非pc浏览器 -->
    <div v-if="vipDetails.status == 1 && (!isPC || !showPC)" class="common">
      <img :src="vipDetails.image_up" alt="" class="imageUp" @click="download">
      <div class="down">
        <div class="operation" v-if="vipDetails.type == 1 || !isAndroid">
          <div>
            <p>您的账号为：<span>{{ vipDetails.user_name }}</span></p>
            <p>您的密码为：<span>{{ vipDetails.pwd }}</span></p>
          </div>
          <div class="btn copyBtn" :data-clipboard-text="copyText">一键复制</div>
        </div>
        <img :src="vipDetails.image_down" alt="" :class="['imageDown', vipDetails.type == 2 && isAndroid ? 'isWechatAuth' : '']">
      </div>
    </div>
    <!-- 切用户 pc浏览器 -->
    <div v-if="isPC && showPC" class="pc_code">
      <div class="pc_container">
        <p>请使用手机点击【继续查看】或手机扫码访问</p>
        <img :src="qrcodeLink" alt="">
        <p class="pc_container_check" @click="check">点击继续查看</p>
      </div>
    </div>
    <!-- 失效链接 -->
    <img :src="vipDetails.image_default" alt="" v-if="vipDetails.status == 0" class="expired">
  </div>
</template>

<script>
import { vipUserDetails } from '@/apis/gameJump';
import Clipboard from "clipboard";
import { Toast } from "vant";
import { isAndroid, isPC } from '@/libs/utils';
import QRCode from 'qrcode'

export default {
  data() {
    return {
      vipDetails: {},
      copyText: '',
      isAndroid: isAndroid(),
      isPC: isPC(),
      qrcodeLink: '',
      showPC: false,
    };
  },
  async mounted() {
    if (this.isPC) {
      this.qrcodeLink = await QRCode.toDataURL(window.location.href);
      this.showPC = true;
      return;
    }
    this.getVipData()
    this.copyInit();
  },
  computed: {
  },
  methods: {
    copyInit() {
      this.copy = new Clipboard(".copyBtn");
      this.copy.on("success", () => {
        Toast("复制成功");
      });
    },
    async getVipData() {
      const { credential } = this.$route.query;
      const r = await vipUserDetails({ credential });
      if (r.ret === 1) {
        this.vipDetails = r.content;
        this.copyText = `您的账号为${r.content.user_name} 您的密码为${r.content.pwd}`
      }
    },
    // 下载包 根据不同浏览器处理不同
    download() {
      window.open(this.vipDetails.download_url)
      // const ua = window.navigator.userAgent.toLowerCase();
      // if (ua.match(/MicroMessenger/i) == 'micromessenger') {

      // } else {

      // }
    },
    // PC 端点击继续查看
    check() {
      // 手动设置一次 rem 根节点大小
      const htmlTag = document.getElementsByTagName('html')[0];
      htmlTag.style.fontSize = '75px';
      // 请求接口，展示 h5 页面
      this.showPC = false;
      this.getVipData()
      this.copyInit();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  .expired {
    display: block;
    width: 100%;
    height: 100%;
  }
  .common {
    width: 100%;
    height: 100%;
    background-color: #393939;
    padding-top: 10px;
    .imageUp {
      display: block;
      width: 338px;
      height: 189.5px;
      margin: auto;
      margin-bottom: 16px;
      border-radius: 13px;
    }
  }
  .down {
    width: 100%;
    height: calc(100% - 189.5px - 16px);
    background: #FFFFFF;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    padding: 15px;
    box-sizing: border-box;
    padding-top: 29px;
    .operation {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;
      p {
        color: #A469D7;
        font-weight: 700;
        font-size: 14px;
        margin: 10px 0;
        margin-right: 20px;;
        > span {
          color: #969BF9;
        }
      }
      .btn {
        width: 93px;
        height: 28px;
        background: linear-gradient(0deg,#6a7ff8 0%, #e8ebff 100%);
        border-radius: 13px;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        &:active {
          transform: scale(0.95);
        }
      }
    }
    .imageDown {
      width: 345.5px;
      height: 343.5px;
      display: block;
      margin: auto;
      border-radius: 13px;
      &.isWechatAuth {
        height: 430.5px;
      }
    }
  }
  .pc_code {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('//assets.hzwxbz2.cn/sy/wxactivity/img/20241022-151045.jpeg') no-repeat;
    background-size: 100% 100%;
    .pc_container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 200PX;
      height: 270PX;
      background: #fdfeff;
      border-radius: 14.67PX;
      box-shadow: -0.33PX 0PX 2PX 0.33PX rgba(197,197,197,0.98), NaNPX NaNPX 1PX NaNPX #fff5b7 inset; 
      font-size: 14PX;
      text-align: center;
      color: #000;
      line-height: 20PX;
      padding: 27PX 15PX;
      > p {
        margin-bottom: 10PX;
      }
      img {
        width: 150PX;
        height: 150PX;
        background: #ffffff;
        border: 1.33PX solid #e1f2ff;
        border-radius: 6.67PX;
      }
      .pc_container_check {
        color: #002271;
        margin-top: 6PX;
        margin-bottom: 6PX;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
.pc_main {
  width: 375px;
  margin: 0 auto;
  background-color: black;
  .expired {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
